import React, { Component } from "react";
import { connect } from "react-redux";

import CheckIcon from "@material-ui/icons/Check";
import LinearProgress from "@material-ui/core/LinearProgress";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import Popover from "@material-ui/core/Popover";
import { withRouter } from "react-router";
import { withStyles } from "@material-ui/core/styles";
import { Apply_Promo, setProduct } from "../../store/actions";
import {
  getConditionsLeftAsText,
  getSmartPromoProgress,
} from "../../Helpers/promotions";
import ClaimModal from "./ClaimModal";

const styles = (theme) => ({
  bar: {
    borderRadius: 100,
    boxShadow: "0 3px 5px 2px rgba(255, 105, 135, .3)",
  },
});

class PromotionActionButton extends Component {
  state = { anchorEl: null, showClaimModal: false };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };
  handleOpen = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };
  SendToAddProducts(products, categories) {
    if (products.length) {
      this.props.setProduct();
      const returnURL = this.props.returnURL;
      this.props.history.replace(
        `/product/${products[0].category}/${
          products[0].parent ? products[0].parent + "/" : ""
        }${products[0].slug}`,
        { pending_items: products.slice(1), returnURL: returnURL }
      );
    }
    if (categories.length) {
      if (categories.length === 1 && categories[0].categories.length === 1) {
        const singleCategory = this.props.categories.find(
          (storeCat) => storeCat.id === categories[0].categories[0]
        );
        if (singleCategory) {
          this.props.history.replace(`/category/${singleCategory.slug}`);
        }
      } else {
        this.setState({ showClaimModal: true });
      }
    }
  }
  render() {
    const {
      secondLoading,
      isCoupon,
      appliedPromotions,
      appliedCoupon,
      promo,
      discounts,
      language,
      classes,
      settings,
      authUser,
    } = this.props;
    const { showClaimModal } = this.state;
    if (!promo) return <></>;

    const themeColor = this.props.themeColor
      ? this.props.themeColor
      : "#0099cc";
    let isApplied = false;
    let discountedItems = [];
    let discountedCategories = [];
    let progressValue = 0;
    let conditionsLeft = { value: 0, number: 0, products: [] };
    let conditionsLeftText = {};

    if (!isCoupon) {
      let discount = appliedPromotions.find((p) => p.id === promo.id);
      if (discount) {
        discountedItems = discounts.products.filter(
          (p) => p.promo === discount.id && p.quantity > 0
        );

        discountedCategories = discounts.category_free.filter(
          (p) => p.promo === discount.id && p.quantity > 0
        );

        isApplied = true;
      }

      if (!isApplied) {
        ({ progressValue, conditionsLeft } = getSmartPromoProgress(
          promo,
          this.props
        ));
        conditionsLeftText = getConditionsLeftAsText(
          conditionsLeft,
          this.props
        );
      }
    }

    const notAppliedPromo =
      (appliedCoupon && promo.id !== appliedCoupon.id) || !appliedCoupon;

    const open = Boolean(this.state.anchorEl);
    const id = open ? "simple-popover" : undefined;

    const isProductPromo =
      !isCoupon &&
      promo?.conditions.length === 1 &&
      promo.conditions[0].type == "products" &&
      promo.conditions[0]?.products?.length == 1;
    const isloyaltyPromo = promo.loyalty_points_cost > 0;

    const isExpired =
      (!isCoupon &&
        authUser &&
        promo.quantity_per_user >= 1 &&
        promo.quantity_per_user <= promo.user_quantity_used) ||
      (settings.allow_one_promo &&
        !isApplied &&
        !isloyaltyPromo &&
        (appliedPromotions.length || appliedCoupon)) ||
      conditionsLeft?.expired;

    const unsufficentPoints =
      authUser && promo.loyalty_points_cost > authUser?.points;

    const hasProductsToBeClaimed =
      discountedCategories.length || discountedItems.length;

    if (
      (isloyaltyPromo ||
        promo.quantity_per_user > 0 ||
        conditionsLeft?.userError) &&
      !authUser
    )
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "15px",
            alignItems: "center",
            flexDirection: language === "arabic" && "row-reverse",
          }}
        >
          <div
            onClick={() => this.props.history.push("/profile")}
            style={{
              fontSize: "12px",
              color: "red",
              borderColor: "red",
              fontFamily: language == "english" ? "Quicksand" : "Cairo",
              textTransform: "capitalize",
            }}
            className="btn"
          >
            <span>
              {language === "english"
                ? "Login to claim promotion"
                : "سجل دخولك لكي تحصل على العرض"}
            </span>
          </div>
          {promo.loyalty_points_cost > 0 && (
            <p
              style={{
                fontSize: "14px",
                fontWeight: "bold",
                position: "relative",
                right: (language == "english" && 6) || -6,
                fontFamily: language == "english" ? "Quicksand" : "Cairo",
              }}
            >
              {`${promo.loyalty_points_cost} Points`}
            </p>
          )}
        </div>
      );
    if (isExpired || unsufficentPoints) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "15px",
            alignItems: "center",
            flexDirection: language === "arabic" && "row-reverse",
          }}
        >
          <div
            style={{
              fontSize: "12px",
              color: "red",
              borderColor: "red",
              fontFamily: language == "english" ? "Quicksand" : "Cairo",
              textTransform: "capitalize",
            }}
            className="btn"
          >
            <span>
              {isExpired
                ? language === "english"
                  ? "Expired"
                  : "منتهي الصلاحية"
                : language === "english"
                ? "Not enough points"
                : "نقاط غير كافيه"}
            </span>
          </div>
          {promo.loyalty_points_cost > 0 && (
            <p
              style={{
                fontSize: "14px",
                fontWeight: "bold",
                position: "relative",
                right: (language == "english" && 6) || -6,
                fontFamily: language == "english" ? "Quicksand" : "Cairo",
              }}
            >
              {`${promo.loyalty_points_cost} Points`}
            </p>
          )}
        </div>
      );
    }

    if (isProductPromo && (!isApplied || promo.repeatable))
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "15px",
            alignItems: "center",
            flexDirection: language === "arabic" && "row-reverse",
          }}
        >
          <div
            onClick={() => {
              let products = [...promo.conditions[0].products];
              promo.discounts
                .filter((d) => d.type === "products")
                .forEach((d) => {
                  products = products.concat(d.products);
                });
              this.SendToAddProducts(products);
            }}
            style={{
              fontSize: "12px",
              color: themeColor,

              borderColor: themeColor,
              backgroundColor: "white",
              fontFamily: language == "english" ? "Quicksand" : "Cairo",
              textTransform: "capitalize",
            }}
            className="btn"
          >
            <span>
              {language === "english" ? "Get Promotion" : "احصل على العرض"}
            </span>
          </div>
        </div>
      );

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: !this.props.fromCart && "15px",

          alignItems: "end",
          flexDirection:
            !this.props.fromCart && language === "arabic" && "row-reverse",
          whiteSpace: "nowrap",
        }}
      >
        {(isCoupon || isloyaltyPromo || isApplied) && (
          <button
            disabled={secondLoading}
            onClick={() => {
              if (isApplied && hasProductsToBeClaimed) {
                this.SendToAddProducts(discountedItems, discountedCategories);
              } else if (isCoupon || isloyaltyPromo) {
                this.props.Apply_Promo(
                  promo?.id !== appliedCoupon?.id && {
                    ...promo,
                    promo: { ...promo },
                    isSmartPromo: isloyaltyPromo && true,
                  }
                );
              }
            }}
            style={{
              fontSize: "12px",
              height: 33,
              color:
                ((isCoupon || isloyaltyPromo) && notAppliedPromo) ||
                (!isCoupon && hasProductsToBeClaimed)
                  ? themeColor
                  : "white",
              borderColor: themeColor,
              backgroundColor:
                ((isCoupon || isloyaltyPromo) && notAppliedPromo) ||
                (!isCoupon && hasProductsToBeClaimed)
                  ? "white"
                  : themeColor,
              boxShadow: "none",

              fontFamily: language == "english" ? "Quicksand" : "Cairo",
              textTransform: "capitalize",
            }}
            type="button"
            className="btn btn-outline-primary "
          >
            {isApplied && hasProductsToBeClaimed ? (
              language === "english" ? (
                "get products"
              ) : (
                "احصل على المنتجات"
              )
            ) : isCoupon || isloyaltyPromo ? (
              notAppliedPromo ? (
                <span>{language === "english" ? "Apply ?" : "فعّل ؟"}</span>
              ) : language === "english" ? (
                <div>
                  <span>{"Applied"}</span>
                  <CheckIcon
                    style={{
                      position: "relative",
                      bottom: "1px",
                      left: "5px",
                    }}
                  />
                </div>
              ) : (
                <div>
                  <CheckIcon
                    style={{
                      position: "relative",
                      bottom: "1px",
                      right: "5px",
                    }}
                  />
                  <span>{"مفعّل"}</span>
                </div>
              )
            ) : language === "english" ? (
              <div>
                <span>{"Applied"}</span>
                <CheckIcon
                  style={{
                    position: "relative",
                    bottom: "1px",
                    left: "5px",
                  }}
                />
              </div>
            ) : (
              <div>
                <CheckIcon
                  style={{
                    position: "relative",
                    bottom: "1px",
                    right: "5px",
                  }}
                />
                <span>{"مفعّل"}</span>
              </div>
            )}
          </button>
        )}
        {promo.loyalty_points_cost > 0 && !this.props.fromCart && (
          <p
            style={{
              fontSize: "14px",
              fontWeight: "bold",
              position: "relative",
              right: (language == "english" && 6) || -6,
              fontFamily: language == "english" ? "Quicksand" : "Cairo",
              alignSelf: "center",
            }}
          >
            {`${promo.loyalty_points_cost} ${
              language === "arabic" ? "نقطه" : "Points"
            }`}
          </p>
        )}
        {(!isloyaltyPromo || !notAppliedPromo) &&
          conditionsLeftText.length > 0 && (
            <div
              style={{
                width: "100%",
                position: "relative",

                marginLeft: isloyaltyPromo && 15,
                marginRight: isloyaltyPromo && 15,
                textAlign: (language == "arabic" && "right") || "left",
              }}
            >
              {Boolean(conditionsLeftText.length) && (
                <HelpOutlineIcon
                  onClick={this.handleOpen}
                  color="primary"
                  style={{ marginBottom: 1 }}
                />
              )}
              <p
                style={{
                  position: "absolute",
                  bottom: -16,
                  left: "50%",
                  color: progressValue >= 50 ? "white" : this.props.themeColor,
                  fontWeight: "bold",
                  fontFamily: language == "english" ? "Quicksand" : "Cairo",
                  zIndex: 2,
                }}
              >
                {progressValue} %
              </p>
              <LinearProgress
                color="primary"
                variant="determinate"
                value={progressValue}
                classes={{ bar: classes.bar }}
                style={{
                  transform: language === "english" ? "" : "rotateY(180deg)",
                  borderRadius: "100px",
                  height: "15px",
                }}
              />

              <div
                style={{
                  display: "flex",
                  position: "absolute",
                  bottom: 20,
                  right: language === "arabic" && 0,
                  flexDirection: language === "arabic" && "row-reverse",
                }}
              >
                {progressValue >= 50 ? (
                  <p
                    className="mx-2"
                    style={{
                      fontWeight: "bold",
                      fontFamily: language == "english" ? "Quicksand" : "Cairo",
                    }}
                  >
                    {conditionsLeftText.length > 1
                      ? language === "english"
                        ? "You are almost there !"
                        : " ! تكاد ان تحصل على العرض"
                      : ""}
                  </p>
                ) : null}
              </div>
              <Popover
                PaperProps={{ style: { padding: 10 } }}
                id={id}
                open={open}
                anchorEl={this.state.anchorEl}
                onClose={this.handleClose}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
              >
                <div
                  className={`${
                    language === "english"
                      ? "pr-2 pl-1 text-left"
                      : "pr-2 pl-3 text-right"
                  }`}
                  style={{
                    fontWeight: "bold",
                    fontFamily: language == "english" ? "Quicksand" : "Cairo",
                    direction: language == "english" ? "ltr" : "rtl",
                  }}
                >
                  <p
                    className={`${
                      language === "english"
                        ? "m-3 text-left"
                        : "m-3 text-right"
                    }`}
                  >
                    {language == "english"
                      ? settings?.custom_texts.promotion_conditions
                      : settings?.custom_texts.promotion_conditions_ar}
                  </p>
                  <ul
                    className={`${language === "english" ? "" : "text-right"}`}
                  >
                    {conditionsLeftText.map((c, index) => (
                      <li key={"condition" + index}>{c}</li>
                    ))}
                  </ul>
                </div>
              </Popover>
            </div>
          )}

        <ClaimModal
          open={showClaimModal}
          onClose={() => this.setState({ showClaimModal: false })}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    settings: state.store.store.settings,
    language: state.store.language,
    secondLoading: state.store.secondLoading,
    appliedPromotions: state.cart.smart_promos,
    appliedCoupon: state.cart.promos,
    discounts: state.cart.discounts,
    totalPrice: state.cart.price,
    totalItems: state.cart.number_of_items,
    themeColor: state.store.store.settings.dark,
    cart: state.cart.cart,
    customerAddress: state.customers.address,
    branch: state.branch,
    authUser: state.auth.user,
    delivery: state.delivery,
    categories: state.store.store.categories,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    Apply_Promo: (promo) => dispatch(Apply_Promo(promo)),
    setProduct: () => dispatch(setProduct()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withStyles(styles)(PromotionActionButton)));
